import quickBooks from "assets/quickBooks.svg";

import quickBooksDesktop from "assets/quickBooksDesktop.svg";

import xero from "assets/xero.svg";

import zoho from "assets/zoho.svg";

import { memoize } from "decko";

export default class IntegrationServices {
  static ABRA_FLEXI_BEE = { label: "Abra FlexiBee", value: "abraFlexiBee", documentsOnlyExport: true, showExportSettings: true };

  static MONEY_S_THREE = { label: "Money S3", value: "s3money" };

  static POHODA = { label: "Pohoda", value: "pohoda" };

  static QUICK_BOOKS_DESKTOP = {
    label: "QuickBooks Desktop",
    shortLabel: "QuickBooks Desktop",
    value: "quickBooksDesktop",
    logo: quickBooksDesktop
  };

  static QUICK_BOOKS = {
    label: "QuickBooks Online",
    altLabel: "QuickBooks Online Accountant",
    shortLabel: "QuickBooks",
    value: "quickBooks",
    logo: quickBooks,
    fullIntegration: true,
    availableForRpa: true
  };

  static XERO = {
    label: "Xero",
    shortLabel: "Xero",
    value: "xero",
    logo: xero,
    fullIntegration: true,
    availableForRpa: true
  };

  static ZOHO = {
    label: "Zoho Books",
    shortLabel: "Zoho",
    value: "zoho",
    logo: zoho,
    fullIntegration: true,
    manualSelection: true
  };

  @memoize
  static getList() {
    return Object.values(IntegrationServices);
  }

  @memoize
  static getFullIntegratedList() {
    return Object.values(IntegrationServices).filter((service) => service.fullIntegration);
  }

  @memoize
  static getRpaEnabledList() {
    return Object.values(IntegrationServices).filter((service) => service.availableForRpa);
  }

  @memoize
  static getByValue(value) {
    return IntegrationServices.getList().find((service) => service.value === value);
  }
}
